import css from './OrderBreakdown.module.css';
import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { isFreeGroupSession } from '../../util/soulwise-marketplace/listingType';

export const ListingTotalPrice = ({ listing, intl }) => {
  // OrderBreakdown callers (e.g. EstimatedCustomerBreakdownMaybe) may omit listing
  const { publicData, price } = listing?.attributes || {};
  const { listingType } = publicData || {};

  const formattedTotalPrice = price ? (
    formatMoney(intl, price)
  ) : (
    <FormattedMessage id="OrderBreakdown.price.error" />
  );

  const totalPrice = isFreeGroupSession(listingType) ? (
    <FormattedMessage id="OrderBreakdown.price.free" />
  ) : (
    formattedTotalPrice
  );

  return (
    <>
      <div className={css.lineItemTotal}>
        <div className={css.totalLabel}>
          <FormattedMessage id="OrderBreakdown.total" />
        </div>
        <div className={css.totalPrice}>{totalPrice}</div>
      </div>
    </>
  );
};
